import { type } from 'skin/event';
import axios from 'axios';
import cnfTask from 'config_task';

function Refresh() {
	axios
		.get(`${cnfTask.url}api/auth/refresh`, {
			withCredentials: true,
			headers: {
				Task: cnfTask.code,
			},
		})
		.then(function (response) {
			const user = JSON.stringify(response.data.user)
			localStorage.setItem('token', response.data.accessToken);
			localStorage.setItem('user', user);
			type('ok');
		})
		.catch((e) => {
			console.log('Refresh error', e.response?.data);
			localStorage.clear('token');
			localStorage.clear('user');
			type('login');
		});
}

export default Refresh;
